import React from "react";
import { Link } from "react-router-dom";
import classes from "./Homepage.module.scss";
function Homepage() {
  return (
    <div className={classes.homepage}>
      <div className={classes.homepageTop}>
        <div className={classes.homepageTopSlides}>
          <img
            src='https://images.pexels.com/photos/1591056/pexels-photo-1591056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            alt=''
          />
        </div>
        {/* <div className={classes.homepageTopSlides}>
          <img
            src='https://images.pexels.com/photos/4968663/pexels-photo-4968663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            alt=''
          />
        </div>
        <div className={classes.homepageTopSlides}>
          <img
            src='https://images.pexels.com/photos/4417/black-and-white-people-bar-men.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            alt=''
          />
        </div>
        <div className={classes.homepageTopSlides}>
          <img
            src='https://images.pexels.com/photos/315788/pexels-photo-315788.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            alt=''
          />
        </div>
        <a className={classes.homepageTopPrev} onclick='plusSlides(-1)'>
          &#10094;
        </a>
        <a className={classes.homepageTopNext} onclick='plusSlides(1)'>
          &#10095;
        </a> */}
      </div>
      <div className={classes.homepageMiddle}></div>
      <div className={classes.homepageMiddleCards}>
        <div className={classes.homepageMiddleCard}>
          <Link to='/intrinsicvaluecalculator'>
            <img
              src='https://images.pexels.com/photos/5466785/pexels-photo-5466785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
              alt='calculator'
            />
            <h3>Intrinsic Value Calculator</h3>
            <p>
              Calculate Intrinsic Value of Stock to know Stock is Undervalued or
              Overvalued
            </p>
          </Link>
        </div>
        <div className={classes.homepageMiddleCard}>
          <Link to='/blogs'>
            <img
              src='https://images.pexels.com/photos/5466785/pexels-photo-5466785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
              alt=''
            />
            <h3>Blogs</h3>
            <p>Blogs on Personal Finance and on latest trading topics</p>
          </Link>
        </div>
        <div className={classes.homepageMiddleCard}>
          <Link to='/news'>
            <img
              src='https://images.pexels.com/photos/5466785/pexels-photo-5466785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
              alt=''
            />
            <h3>News</h3>
            <p>Daily Update of Market and weekly & monthly top news</p>
          </Link>
        </div>
        <div className={classes.homepageMiddleCard}>
          <Link>
            <img
              src='https://images.pexels.com/photos/5466785/pexels-photo-5466785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
              alt=''
            />
            <h3>Stock Market Modules</h3>
            <p>Learn About Stock Market From A to Z</p>
          </Link>
        </div>
        <div className={classes.homepageMiddleCard}>
          <img
            src='https://images.pexels.com/photos/5466785/pexels-photo-5466785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            alt=''
          />
          <h3>Mutual Fund Modules</h3>
          <p>Learn What is Mutual Fund and how to select best mutual fund</p>
        </div>
      </div>
      <div className={classes.homepageBottom}></div>
    </div>
  );
}

export default Homepage;
